module.exports = __webpack_public_path__ + "media/images/HeartRed-d82df578.svg";